import { useSiteConfig } from "@/hooks/useSiteConfig";
import { LogoMark } from "./primitives";

const RESOURCES = [
  { label: "Whitepaper", href: "#whitepaper", soon: false },
  { label: "Documentation", href: null, soon: true },
  { label: "Explorer", href: null, soon: true },
  { label: "Governance", href: null, soon: true },
];

const LEGAL_LINKS = [
  { label: "Risk Disclosure", href: "#legal" },
  { label: "Disclaimer", href: "#legal" },
  { label: "Privacy Policy", href: null },
  { label: "Terms of Use", href: null },
];

const scrollTo = (href) => window.dispatchEvent(new CustomEvent("jcv:scroll", { detail: href }));

const Footer = () => {
  const config = useSiteConfig();
  return (
    <footer className="border-t border-line bg-[#050D16]" data-testid="footer">
      <div className="section-shell py-16 lg:py-20">
        <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
          <div>
            <LogoMark />
            <p className="mt-5 font-mono text-[11px] tracking-[0.25em] uppercase text-slate" data-testid="footer-tagline">
              JCV • BNB Smart Chain • BEP-20
            </p>
            <p className="mt-4 max-w-xs text-sm text-slate leading-relaxed">
              A fixed-supply, utility-focused digital asset designed to power a growing decentralized ecosystem.
            </p>
          </div>

          <nav aria-label="Footer navigation">
            <h3 className="font-mono text-[11px] tracking-[0.3em] uppercase text-teal">Navigate</h3>
            <ul className="mt-5 space-y-2.5">
              {config.nav.slice(1).map((n) => (
                <li key={n.href}>
                  <button onClick={() => scrollTo(n.href)} className="text-sm text-slate hover:text-mist transition-colors duration-300" data-testid={`footer-nav-${n.href.slice(1)}`}>
                    {n.label}
                  </button>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h3 className="font-mono text-[11px] tracking-[0.3em] uppercase text-teal">Resources</h3>
            <ul className="mt-5 space-y-2.5">
              {RESOURCES.map((r) => (
                <li key={r.label}>
                  {r.href ? (
                    <button onClick={() => scrollTo(r.href)} className="text-sm text-slate hover:text-mist transition-colors duration-300" data-testid={`footer-resource-${r.label.toLowerCase()}`}>
                      {r.label}
                    </button>
                  ) : (
                    <span className="text-sm text-slate/60" data-testid={`footer-resource-${r.label.toLowerCase()}`}>
                      {r.label} <span className="font-mono text-[10px] tracking-[0.15em] uppercase text-slate/50">— Coming Soon</span>
                    </span>
                  )}
                </li>
              ))}
            </ul>
            <h3 className="mt-8 font-mono text-[11px] tracking-[0.3em] uppercase text-teal">Community</h3>
            <ul className="mt-5 space-y-2.5">
              {config.socials.map((s) => (
                <li key={s.name} className="text-sm text-slate/60" data-testid={`footer-social-${s.name.toLowerCase().replace(/[^a-z]/g, "-")}`}>
                  {s.name} <span className="font-mono text-[10px] tracking-[0.15em] uppercase text-slate/50">— To Be Announced</span>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-mono text-[11px] tracking-[0.3em] uppercase text-teal">Legal</h3>
            <ul className="mt-5 space-y-2.5">
              {LEGAL_LINKS.map((l) => (
                <li key={l.label}>
                  {l.href ? (
                    <button onClick={() => scrollTo(l.href)} className="text-sm text-slate hover:text-mist transition-colors duration-300" data-testid={`footer-legal-${l.label.toLowerCase().replace(/\s+/g, "-")}`}>
                      {l.label}
                    </button>
                  ) : (
                    <span className="text-sm text-slate/60" data-testid={`footer-legal-${l.label.toLowerCase().replace(/\s+/g, "-")}`}>
                      {l.label} <span className="font-mono text-[10px] tracking-[0.15em] uppercase text-slate/50">— Coming Soon</span>
                    </span>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-14 border-t border-line pt-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="font-mono text-xs text-slate" data-testid="footer-copyright">
            © 2026 Jovino Coin. All rights reserved.
          </p>
          <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-slate/60">
            Fixed Maximum Supply — <span className="text-gold">72,000,000,000,000 JCV</span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
